import React from 'react';
import { Shield, Edit, Trash2 } from 'lucide-react';
import { IconButton } from '@atoms';

export interface RoleActionButtonsProps {
  onManagePermissions: () => void;
  onEdit: () => void;
  onDelete: () => void;
  isDeleteDisabled?: boolean;
}

export const RoleActionButtons: React.FC<RoleActionButtonsProps> = ({
  onManagePermissions,
  onEdit,
  onDelete,
  isDeleteDisabled = false
}) => {
  return (
    <div className="flex items-center justify-end space-x-2">
      <IconButton
        icon={Shield}
        onClick={onManagePermissions}
        variant="ghost"
        size="sm"
        className="text-blue-600 hover:text-blue-800"
        title="Manage Permissions"
      />
      <IconButton
        icon={Edit}
        onClick={onEdit}
        variant="ghost"
        size="sm"
        className="text-primary-600 hover:text-primary-800"
        title="Edit Role"
      />
      <IconButton
        icon={Trash2}
        onClick={onDelete}
        variant="ghost"
        size="sm"
        className="text-error-600 hover:text-error-800"
        title="Delete Role"
        disabled={isDeleteDisabled}
      />
    </div>
  );
};
